import React, { useState, useRef, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { FiLogOut, FiGrid, FiChevronDown } from 'react-icons/fi';
import { clearToken } from '../api';
import { useMe } from '../App';
import { Icon } from '../icons';
import { appColor } from './HomeGrid';

export default function AppShell() {
  const me = useMe();
  const nav = useNavigate();
  const loc = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const menuRef = useRef();
  const userRef = useRef();

  useEffect(() => {
    function onClick(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
      if (userRef.current && !userRef.current.contains(e.target)) setUserOpen(false);
    }
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  function logout() { clearToken(); nav('/login', { replace: true }); }
  const initials = me.user.name.split(' ').map((s) => s[0]).slice(0, 2).join('').toUpperCase();

  const parts = loc.pathname.split('/');
  const curKey = parts[2];
  const allChildren = me.modules.flatMap((m) => m.children.map((c) => ({ ...c, parent: m })));
  const curChild = allChildren.find((c) => c.key === curKey);
  const curApp = curChild ? curChild.parent : null;
  const appMenu = curApp ? curApp.children : [];
  const brandColor = curApp ? appColor(curApp.key) : '#017E84';

  return (
    <div className="odoo-root">
      <header className="o-navbar">
        <div className="o-menu-toggle" ref={menuRef}>
          <button className="o-apps-btn" onClick={() => setMenuOpen((v) => !v)} title="Apps"><FiGrid /></button>
          {menuOpen && (
            <div className="o-apps-drop">
              {me.modules.map((app) => (
                <button key={app.key} className="o-apps-item" onClick={() => {
                  setMenuOpen(false);
                  const first = app.children[0];
                  if (first) nav('/m/' + first.key);
                }}>
                  <span className="ai" style={{ background: appColor(app.key) }}><Icon name={app.icon} /></span>
                  <span>{app.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="o-brand" onClick={() => nav('/')}>
          <span className="o-brand-dot" style={{ color: brandColor }}>◆</span>
          <span className="o-brand-name">{curApp ? curApp.label : 'ADMPL'}</span>
        </div>

        {appMenu.length > 0 && (
          <nav className="o-appmenu">
            {appMenu.map((item) => (
              <button key={item.key}
                className={'o-appmenu-item' + (item.key === curKey ? ' active' : '')}
                onClick={() => nav('/m/' + item.key)}>{item.label}</button>
            ))}
          </nav>
        )}

        <div className="o-spacer" />

        <div className="o-systray" ref={userRef}>
          <button className="o-user" onClick={() => setUserOpen((v) => !v)}>
            <span className="o-avatar">{initials}</span>
            <span className="o-user-name">{me.user.name.split(' ')[0]}</span>
            <FiChevronDown size={14} />
          </button>
          {userOpen && (
            <div className="o-user-drop">
              <div className="o-user-head">
                <div className="o-avatar lg">{initials}</div>
                <div>
                  <div className="o-ud-name">{me.user.name}</div>
                  <div className="o-ud-role">{me.user.role}</div>
                </div>
              </div>
              <button className="o-ud-item" onClick={() => { setUserOpen(false); nav('/'); }}><FiGrid /> Home</button>
              <button className="o-ud-item" onClick={logout}><FiLogOut /> Log out</button>
            </div>
          )}
        </div>
      </header>

      <main className="o-content">
        <Outlet />
      </main>
    </div>
  );
}
